<template>
	<div id="" ref="">
		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; margin-top:-1px; margin-left:20px;">{{getLangText('模板类型名称')}}</div>
			<input type="text" style="width:150px;" maxlength="30" v-model="tmName">
		</div>

		<div style="float:left; width:100%; height:40px; border:0px solid red; margin-top:60px;">
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-left:50px;" @click="onCancelClick">{{getLangText("取消")}}</div>
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-right:50px; float:right;" @click="onOKClick">{{getLangText("确定")}}</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'tmInfo',
	components:{

	},
	data () {
		return {
			tmId: 0,
			tmName: "",
		}
	},
	mounted: function(){
		this.tmId   = this.$route.query.tmId;
		this.tmName = this.$route.query.tmName;
	},
	computed:{

	},
	methods:{
		onCancelClick: function(){
			this.$parent.onPopWinClose( );
		},
		onOKClick: function( res ){
			if( this.tmName == "" ) return;
			if( this.tmId == 0 )
			{
				let body={ tmName: this.tmName };
				this.doTrade( "POST", ServAddr+"/api/template/tmAdd", this.onTMAddOK, true, body, null );
			}
			else
			{
				let body={ tmId: this.tmId, tmName: this.tmName };
				this.doTrade( "PUT", ServAddr+"/api/template/tmMod", this.onTMAddOK, true, body, null );
			}
		},
		onTMAddOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			this.$parent.onPopWinClose2();
			if( data.code == 200 )
				 this.appRoot.app.showDlgTip( 1200, LangText("保存成功"), this.CLR.Suc, this.$parent.onPopWinClose, true );
			else this.appRoot.app.showDlgTip( 1200, LangText("保存失败"), this.CLR.Err, this.$parent.onPopWinClose, true );
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// tmInfo.vue?286157ca